import apiClient from './apiClient';

const URL = (process.env.REACT_APP_API_URL || 'http://localhost:4000/api') + '/cc-asistencia-laboral';
const CIDI_URL = (process.env.REACT_APP_API_URL || 'http://localhost:4000/api') + '/cc-asistencias/participantes';

const handleResponse = async (response) => {
  if (!response.ok) {
    let errorData;
    try {
      errorData = await response.json();
    } catch {
      throw new Error(`Error ${response.status}: Ha ocurrido un error inesperado.`);
    }
    throw new Error(errorData.message || 'Error en la solicitud');
  }
  return response.json();
};

/**
 * Consulta los datos sanitizados de una persona en CiDi por CUIL (Público).
 */
export const getPersonaCidi = async (cuil) => {
  const cleanCuil = String(cuil || '').replace(/\D/g, '');
  const response = await fetch(`${CIDI_URL}/cidi/${cleanCuil}`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  });
  return handleResponse(response);
};

/**
 * Consulta el estado de asistencia de hoy para un trabajador por CUIL (Público).
 */
export const getEstadoHoy = async (cuil) => {
  const cleanCuil = String(cuil || '').replace(/\D/g, '');
  const response = await fetch(`${URL}/estado-hoy/${cleanCuil}`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  });
  return handleResponse(response);
};


/**
 * Registra asistencia laboral vía escaneo QR (Público - Sin autenticación).
 */
export const registrarAsistenciaLaboralQR = async (data) => {
  const response = await fetch(`${URL}/registrar`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  return handleResponse(response);
};

/**
 * Obtiene la lista de asistencias laborales con filtros (Privado - ADM).
 */
export const getAsistenciasLaborales = async (params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '' && value !== 'all') {
      query.append(key, value);
    }
  });

  const queryString = query.toString() ? `?${query.toString()}` : '';
  const response = await apiClient(`${URL}${queryString}`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  });
  return handleResponse(response);
};

/**
 * Obtiene métricas y estadísticas del día (Privado - ADM).
 */
export const getAsistenciasLaboralesStats = async (fecha) => {
  const queryString = fecha ? `?fecha=${fecha}` : '';
  const response = await apiClient(`${URL}/stats${queryString}`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  });
  return handleResponse(response);
};

/**
 * Registra asistencia manual para un trabajador (Privado - ADM).
 */
export const crearAsistenciaLaboralManual = async (data) => {
  const response = await apiClient(`${URL}/manual`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  return handleResponse(response);
};

/**
 * Elimina un registro de asistencia (Privado - ADM).
 */
export const eliminarAsistenciaLaboral = async (id) => {
  const response = await apiClient(`${URL}/${id}`, {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
  });
  return handleResponse(response);
};

export default {
  getPersonaCidi,
  registrarAsistenciaLaboralQR,
  getAsistenciasLaborales,
  getAsistenciasLaboralesStats,
  crearAsistenciaLaboralManual,
  eliminarAsistenciaLaboral,
};
